// extracted by mini-css-extract-plugin
export default {"contactContainer":"styles_contactContainer__F8+kf","cardContainer":"styles_cardContainer__HpxD5"};